export const EmailSignUp = ({ RestService, SessionService }) => async ({ firstName, lastName, email, password }) => {
  const user = await RestService.post( '/api/marketplace/auth', {
    first_name: firstName, last_name: lastName, email, password,
  })
  SessionService.setUserSession( user )
}


export const EmailSignIn = ({ RestService, SessionService }) => async ({ email, password }) => {
  const user = await RestService.post( '/api/marketplace/auth/sign_in', { email, password })
  SessionService.setUserSession( user )
}


export const SignOut = ({ RestService, SessionService }) => async () => {
  await RestService.get( '/api/marketplace/auth/sign_out' )
  SessionService.clearUserSession()
}

export const UpdatePassword = ({ RestService, SessionService }) => async ({ userId, password }) => {
  await RestService.put( '/api/marketplace/auth/password', { userId, password })
  SessionService.refreshSession()
}
